<app-shimmer-loader
  [theme]="{
        'height': '5rem'
      }"
  appearance="line"
/>
<app-shimmer-loader
  [theme]="{
        'height': '3rem'
      }"
  appearance="line"
/>

